import { httpClient } from './http-client.service';

export interface PdfConsoleOptionAPI {
  option_type: 'json' | 'excel';
  label: string;
}

export const pdfConsoleAPI = {
  getOptions: async (): Promise<PdfConsoleOptionAPI[]> => {
    const response = await httpClient.get<any>('pdf-analytics/options');
    return response.data?.data || response.data || [];
  },

  createRun: async (datasetId: string, optionType: string, filenames: string[], pdfMode: 'single' | 'multi' = 'single', transactionRef?: string): Promise<any> => {
    const response = await httpClient.post<any>('pdf-analytics/runs', {
      dataset_id: datasetId,
      option_type: optionType,
      filenames,
      pdf_mode: pdfMode,
      ...(transactionRef ? { transaction_ref: transactionRef } : {}),
    });
    return response.data?.data || response.data;
  },

  getRuns: async (params?: { datasetId?: string; status?: string; transactionRef?: string; page?: number; limit?: number }): Promise<{ runs: any[]; total: number }> => {
    const query = new URLSearchParams({ run_type: 'PDF_CONSOLE' });
    if (params?.datasetId) query.set('dataset_id', params.datasetId);
    if (params?.status) query.set('status', params.status);
    if (params?.transactionRef) query.set('transaction_ref', params.transactionRef);
    if (params?.page != null) query.set('page', String(params.page));
    if (params?.limit != null) query.set('limit', String(params.limit));
    const response = await httpClient.get<any>(`sandbox/runs?${query.toString()}`);
    const payload = response.data?.data ?? response.data;
    if (Array.isArray(payload)) return { runs: payload, total: payload.length };
    return { runs: payload?.runs ?? payload?.items ?? payload?.data ?? [], total: payload?.total ?? 0 };
  },

  getRunResults: async (runId: string, page: number = 1, limit: number = 50): Promise<{ items: any[]; total: number }> => {
    const response = await httpClient.get<any>(`sandbox/runs/${runId}/results?page=${page}&limit=${limit}`);
    const payload = response.data?.data ?? response.data;
    if (Array.isArray(payload)) return { items: payload, total: payload.length };
    return { items: payload?.items ?? payload?.data ?? [], total: payload?.total ?? 0 };
  },

  downloadRunResults: async (runId: string): Promise<{ job_id: string; status: string }> => {
    const response = await httpClient.get<any>(`sandbox/runs/${runId}/download`);
    return response.data?.data || response.data;
  },

  getDownloadJobStatus: async (jobId: string): Promise<{ status: string; download_url?: string; error?: string }> => {
    const response = await httpClient.get<any>(`downloads/status/${jobId}`);
    return response.data?.data || response.data;
  },

  getJobDownloadUrl: async (jobId: string): Promise<string> => {
    const response = await httpClient.get<any>(`downloads/${jobId}/url`);
    const data = response.data?.data || response.data;
    return data?.download_url || '';
  },
};
